'use client'

import Link from 'next/link'
import { useRef, useState } from 'react'

import { useMountEffect } from '@/hooks/useMountEffect'

import type { StorySection } from './slug'

// The section whose heading has passed 35% of the viewport is current.
function currentIndex(sections: StorySection[]) {
  let current = 0
  sections.forEach((section, i) => {
    const el = document.getElementById(section.id)
    if (el && el.getBoundingClientRect().top < window.innerHeight * 0.35) {
      current = i
    }
  })
  return current
}

export function StoryContents({ sections }: { sections: StorySection[] }) {
  const [active, setActive] = useState(0)
  const sectionsRef = useRef(sections)

  useMountEffect(() => {
    let frame = 0
    const onScroll = () => {
      cancelAnimationFrame(frame)
      frame = requestAnimationFrame(() =>
        setActive(currentIndex(sectionsRef.current)),
      )
    }
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => {
      cancelAnimationFrame(frame)
      window.removeEventListener('scroll', onScroll)
    }
  })

  return (
    <nav aria-label="Contents">
      <Link href="/projects" className="story-back">
        ← Projects
      </Link>
      <ol>
        {sections.map((section, i) => (
          <li key={section.id}>
            <a
              href={`#${section.id}`}
              aria-current={i === active ? 'true' : undefined}
            >
              {section.label}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  )
}
